// extracted by mini-css-extract-plugin
export default {"cta":"VH-z","disabled":"WH-z"};